import i18n from '@/plugins/vue-i18n'

export default [
  {
    path: '/vacation',
    name: 'vacation',
    component: () => import('./pages/Vacation.vue'),
    meta: {
      authenticatedOnly: true,
      breadcrumb: [
        {
          text: i18n.t('navigation.vacations'),
          to: '/vacation'
        }
      ]
    }
  }
]
